import { render, staticRenderFns } from "./StPlug.vue?vue&type=template&id=5b86fbd4"
import script from "./StPlug.vue?vue&type=script&lang=js"
export * from "./StPlug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports